import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import * as Icons from "@mui/icons-material";

interface StatCardProps {
  label: string;
  value: string;
  icon: string;
  delta?: string;
  deltaType?: "up" | "down" | "neutral";
  color?: string;
  iconBg?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  icon,
  delta,
  deltaType = "neutral",
  color = "#85D1DB",
  iconBg = "rgba(133,209,219,0.1)",
}) => {
  const IconComponent = (Icons as any)[icon] || Icons.Info;
  const deltaColor =
    deltaType === "up"
      ? "#16a34a"
      : deltaType === "down"
        ? "#dc2626"
        : "#94a3b8";
  const deltaBg =
    deltaType === "up"
      ? "#dcfce7"
      : deltaType === "down"
        ? "#fee2e2"
        : "#f1f5f9";

  return (
    <Card
      sx={{
        borderTop: `4px solid ${color}`,
        borderRadius: "16px",
        overflow: "hidden",
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
          transform: "translateY(-2px)",
        },
      }}
    >
      <CardContent sx={{ p: "24px !important" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1.5,
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 3,
              background: iconBg,
              color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconComponent sx={{ fontSize: 22 }} />
          </Box>
          {delta && (
            <Typography
              sx={{
                fontSize: 11.5,
                fontWeight: 600,
                color: deltaColor,
                background: deltaBg,
                px: 1.2,
                py: 0.5,
                borderRadius: 99,
              }}
            >
              {delta}
            </Typography>
          )}
        </Box>
        <Typography
          sx={{
            fontSize: 32,
            fontWeight: 700,
            color,
            fontFamily: "'JetBrains Mono', monospace",
            letterSpacing: -1,
            mb: 0.5,
          }}
        >
          {value}
        </Typography>
        <Typography
          sx={{
            fontSize: 12,
            color: "#64748b",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          {label}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatCard;
